// extracted by mini-css-extract-plugin
export default {"searchInput":"ZtA2mQ","fullHeight":"gHQAEQ","extraVerticalPadding":"xWIQSD","smallerText":"grYIvA","searchFadeIn":"kIxJ8T"};